import { AvatarImage } from "@design-system/components";
import React from "react";

import { FALLBACK_LOGO_URL } from "../../utils";

function FallbackLogo() {
  return <AvatarImage src={FALLBACK_LOGO_URL} alt="Logo" />;
}

export { FallbackLogo };
